export const pageTitleSx = {
  mb: 2,
  fontSize: 16,
  fontWeight: 500,
  color: '#424242'
};

export const cardSx = {
  bgcolor: '#fff',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.16)',
  overflow: 'hidden'
};

export const editButtonSx = {
  bgcolor: '#EFDCB5',
  border: '1px solid #E5C686',
  borderRadius: '4px',
  color: '#424242',
  boxShadow: 'none',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: '#eed6a6',
    borderColor: '#D9B36A',
    boxShadow: 'none'
  },

  '& .MuiButton-startIcon': {
    mr: 0.5,
  }
};

export const organizationContentSx = {
  p: 1.5,
  py:2.5,
  display: 'flex',
  alignItems: 'center',
  gap: 3
};
export const organizationAvatarSx = {
  width: 120,
  height: 120,
  position: 'relative',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: '#FAFAFA',
  border: '1px solid #E0E0E0',
  borderRadius: '50%'
};

export const organizationAvatarIconSx = {
  fontSize: 50,
  color: '#757575'
};

export const avatarEditButtonSx = {
  width: 40,
  height: 40,
  position: 'absolute',
  right: 0,
  bottom: 0,
  bgcolor: '#F5DDAE',
  border: '1px solid #E3C796',
  color: '#424242',

  '&:hover': {
    bgcolor: '#F0D49B'
  }
};

export const organizationHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

export const organizationTitleSx = {
  fontSize: 16,
  fontWeight: 500,
  color: '#424242',
  mb:1.5
};



export const infoGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(3, auto)'
  },
  columnGap: {
    xs: 2,
    lg: 6
  },
  rowGap: 2.5,
  justifyContent: 'start'
};

export const infoItemSx = {
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5
};

export const infoIconSx = {
  mt: 0.25,
  flexShrink: 0,
  fontSize: 18,
  color: '#4F91D5'
};

export const infoLabelSx = {
  mb: 0.25,
  fontSize: 12,
  lineHeight: 1.5,
  color: '#757575'
};

export const infoValueSx = {
  overflow: 'hidden',
  color: '#424242',
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
  textOverflow: 'ellipsis'
};

export const practiceCardSx = {
  ...cardSx,
  mt: 2.5
};

export const practiceHeaderSx = {
  minHeight: 48,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid #E0E0E0',
  bgcolor:'#FAFAFA'
};

export const practiceTitleSx = {
  fontSize: 16,
  fontWeight: 500,
  color: '#424242'
};

export const practiceRowSx = {
  minHeight: 56,
  px: 2,
  display: 'grid',
  gridTemplateColumns: '18% 10% 11% 10% 22% 19% 10%',
  alignItems: 'center',
  borderBottom: '1px solid #E0E0E0',

  '&:last-child': {
    borderBottom: 0
  },

  '&:hover': {
    bgcolor: '#FFFDF8'
  }
};


export const practiceFieldSx = {
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

export const practiceIconSx = {
  flexShrink: 0,
  fontSize: 20,
  color: '#4F91D5'
};

export const practiceLabelSx = {
  fontSize: 11,
  color: '#757575',
  lineHeight: 1,
};

export const practiceValueSx = {
  overflow: 'hidden',
  color: '#424242',
  fontSize: '0.75rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};

export const practiceActionsSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 0
};

export const actionButtonSx = {
  color: '#757575',
  '&:hover': {
    bgcolor: '#FFF8ED',
    borderColor: '#D9B36A'
  }
};

export const practiceDialogPaperSx = {
  borderRadius: '8px',
  maxHeight: 'calc(100vh - 32px)',
};

export const practiceDialogTitleSx = {
  bgcolor: '#F8FAFD',
  borderBottom: '1px solid #E0E0E0',
  px: 2,
  py: 1.5
};

export const practiceDialogHeaderSx = {
  alignItems: 'flex-start',
  display: 'flex',
  justifyContent: 'space-between'
};

export const practiceDialogTitleTextSx = {
  color: '#424242',
  fontSize: 20,
  fontWeight: 600,
  lineHeight: 1.3
};

export const practiceDialogSubtitleSx = {
  color: '#424242',
  fontSize: 13,
  mt: 0.25
};

export const practiceDialogCloseButtonSx = {
  color: '#424242',
  mt: -0.25
};

export const practiceDialogContentSx = {
  px: 2,
  py: 2,
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

export const practiceFormSx = {
  display: 'flex',
  flexDirection: 'column'
};

export const practiceInputSx = {
  '& .MuiInputBase-root': {
    borderRadius: '4px',
    fontSize: 14,
    minHeight: 56
  },

  '& .MuiInputLabel-root': {
    color: '#757575',
    fontSize: 13
  },

  '& .MuiOutlinedInput-input': {
    color: '#616161',
    px: 1.5,
    py: 1.5
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#BDBDBD'
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#9E9E9E'
  }
};

export const practiceContactFieldSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 1
};

export const practiceAddFieldButtonSx = {
  color: '#757575',
  fontSize:14
};

export const practiceDialogActionsSx = {
  borderTop: '1px solid #E0E0E0',
  gap: 1,
  px: 2,
  py: 2
};

export const practiceCancelButtonSx = {
  color: '#616161',
  fontSize: 12,
  fontWeight: 500
};

export const practiceSubmitButtonSx = {
  bgcolor: '#559AD8',
  borderRadius: '4px',
  color: '#FFFFFF',
  fontSize: 12,
  fontWeight: 500,

  '&:hover': {
    bgcolor: '#438BCB'
  },

  '&.Mui-disabled': {
    bgcolor: '#EEEEEE',
    color: '#BDBDBD'
  }
};

export const fieldSx = {
  
  '& .MuiOutlinedInput-root': {
    fontSize: 13,
    borderRadius: '4px'
  },

  '& .MuiInputLabel-root': {
    fontSize: 13,
    color: '#757575'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1976D2'
  },

  '& .MuiInputBase-input': {
    color: '#616161'
  },
   '& .MuiFormLabel-asterisk': {
    color: '#D32F2F'
  }
};

export const selectSx = {
  '& .MuiInputLabel-root': {
    fontSize: 13,
    color: '#757575'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#757575'
  },
  '& .MuiSelect-select': {
    fontSize: 13,
    color: '#424242'
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px'
  },
  '& .MuiSvgIcon-root': {
    color: '#757575'
  }
};
export const menuProps = {
  slotProps: {
    paper: {
      sx: {
        borderRadius: '4px',
        boxShadow: '0px 4px 16px rgba(0,0,0,0.16)',

        '& .MuiMenu-list': {
          p: 0
        },

        '& .MuiMenuItem-root': {
          minHeight: 38,
          fontSize: 13,
          color: '#757575',

          '&:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-selected': {
            bgcolor: '#fff'
          },

          '&.Mui-selected:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-focusVisible': {
            bgcolor: '#FFF8ED'
          }
        }
      }
    }
  }
};

export const formControlSx = {
  '& .MuiInputLabel-root': {
    fontSize: 12,
    color: '#757575'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1976D2'
  },

  '& .MuiOutlinedInput-root': {
    height: 38,
    borderRadius: '4px',
    fontSize: 12,
    bgcolor: '#fff'
  },

  '& .MuiSelect-select': {
    py: 1.2
  }
};